import { defineMessages } from '@atlassian/jira-intl';

// The following are the description for the translators for the different text that we need translating.
// Unfortunately, this needs to copied to individual files because the i18n text extraction tool needs
// to be able to resolve variables statically.
const NAME_DESC =
	'Name of the site optimizer metric that will be used as the title on the page and menu item.';
const DESCRIPTON_DESC = 'Description of the site optimizer metric.';
const WARNING_DESC = 'Warning message if metric are getting close to the threshold.';
const EXCEEDED_DESC = 'Message to show to the user if metric has exceeded the threshold.';
const RISK_DESC = 'One of the risks when this metric exceeded the threshold.';
const MITIGATION_DESC = 'One of the mitigation options when this metric exceeded the threshold.';
const CURRENT_VALUE_LABEL_DESC = 'Label to be shown next to the current value of the metric.';
const THRESHOLD_VALUE_LABEL_DESC = 'Label to be shown next to the threshold value of the metric.';
const RECOMMENDATION_URL_TEXT_DESC =
	'Text to be shown on the hypertext link to additional documentation.';
const GRAPH_HEADER_DESC = 'Text to be shown on the header of the metric graph.';

export default defineMessages({
	name: {
		id: 'admin-pages-performance.common.assets.project-role-actor.name',
		defaultMessage: 'Project role permissions',
		description: NAME_DESC,
	},
	description: {
		id: 'admin-pages-performance.common.assets.project-role-actor.description',
		defaultMessage:
			"Here's a quick snapshot of the total number of project role permissions across your site.",
		description: DESCRIPTON_DESC,
	},
	analysis: {
		id: 'admin-pages-performance.common.assets.project-role-actor.analysis',
		defaultMessage: 'Analysis',
		description: 'Heading for analysis tab',
	},
	activityLog: {
		id: 'admin-pages-performance.common.assets.project-role-actor.activity-log',
		defaultMessage: 'Activity log',
		description: 'Heading for activity log',
	},
	warning: {
		id: 'admin-pages-performance.common.assets.project-role-actor.warning',
		defaultMessage: 'Your number of project role memberships is nearing the recommended threshold.',
		description: WARNING_DESC,
	},
	exceeded: {
		id: 'admin-pages-performance.common.assets.project-role-actor.exceeded',
		defaultMessage: 'Your number of project role memberships is over the recommended threshold.',
		description: EXCEEDED_DESC,
	},
	risk1: {
		id: 'admin-pages-performance.common.assets.project-role-actor.risk-1',
		defaultMessage:
			'When the number of project role memberships (users or groups) increases, viewing, searching, and creating issues becomes slower.',
		description: RISK_DESC,
	},
	mitigation1: {
		id: 'admin-pages-performance.common.assets.project-role-actor.mitigation-1',
		defaultMessage:
			'Remove users who no longer need access to your site rather than only suspending them. Suspending users removes their permission but not their project role membership.',
		description: MITIGATION_DESC,
	},
	mitigation2: {
		id: 'admin-pages-performance.common.assets.project-role-actor.mitigation-2',
		defaultMessage:
			'Give memberships to groups of users instead of individual users. Granting membership to a group of 50 users count as 1 membership whereas granting memberships to 50 single users counts as 50 memberships.',
		description: MITIGATION_DESC,
	},
	mitigation3: {
		id: 'admin-pages-performance.common.assets.project-role-actor.mitigation-3',
		defaultMessage: 'Use the default project role members in your permission scheme.',
		description: MITIGATION_DESC,
	},
	currentValueLabel: {
		id: 'admin-pages-performance.common.assets.project-role-actor.current-value-label',
		defaultMessage: 'Current project role permissions in your site',
		description: CURRENT_VALUE_LABEL_DESC,
	},
	thresholdValueLabel: {
		id: 'admin-pages-performance.common.assets.project-role-actor.threshold-value-label',
		defaultMessage: 'Recommended maximum number of permissions',
		description: THRESHOLD_VALUE_LABEL_DESC,
	},
	currentValueAriaLabel: {
		id: 'admin-pages-performance.common.assets.project-role-actor.current-value-aria-label',
		defaultMessage: '{number} current project role permissions in your site',
		description: 'Aria Label for the current value',
	},
	thresholdValueAriaLabel: {
		id: 'admin-pages-performance.common.assets.project-role-actor.threshold-value-aria-label',
		defaultMessage: '{number} recommended maximum number of permissions',
		description: 'Aria Label for the threshold value',
	},
	recommendationUrlText: {
		id: 'admin-pages-performance.common.assets.project-role-actor.recommendation-url-text',
		defaultMessage: 'Learn more about optimizing your project role memberships.',
		description: RECOMMENDATION_URL_TEXT_DESC,
	},
	graphHeader: {
		id: 'admin-pages-performance.common.assets.project-role-actor.graph-header',
		defaultMessage: 'Project role permissions over time',
		description: GRAPH_HEADER_DESC,
	},
});
